import React, { useEffect } from 'react';
import axios from 'axios';
import '../../CSS/NovaLoader.css';

const isCraMutation = (config) => {
  const method = String(config?.method || '').toLowerCase();
  const url = String(config?.url || '').toLowerCase();

  const isMutation = ['post', 'put', 'patch', 'delete'].includes(method);
  const isCraUrl =
    url.includes('declaration') ||
    url.includes('déclaration') ||
    url.includes('maladie') ||
    url.includes('cra');

  return isMutation && isCraUrl;
};

const notifyCraRefresh = (config) => {
  try {
    const detail = {
      ts: Date.now(),
      method: config?.method || '',
      url: config?.url || '',
    };

    window.dispatchEvent(new CustomEvent('nova:cra-refresh', { detail }));
    localStorage.setItem('nova_cra_refresh_ts', String(detail.ts));

    const path = decodeURIComponent(window.location.pathname || '').toLowerCase();

    const isCraListPage =
      path.includes('listedeclarations') ||
      path.includes('liste-declarations') ||
      path.includes('liste-declarations') ||
      path.includes('cra');

    const isAddPage =
      path.includes('ajouter') ||
      path.includes('add') ||
      path.includes('create');

    if (isCraListPage && !isAddPage) {
      const lastReload = Number(sessionStorage.getItem('nova_last_cra_auto_reload') || 0);
      const now = Date.now();

      if (now - lastReload > 1200) {
        sessionStorage.setItem('nova_last_cra_auto_reload', String(now));

        setTimeout(() => {
          window.location.reload();
        }, 350);
      }
    }
  } catch (error) {
    console.warn('CRA refresh notification ignored:', error);
  }
};

export const NovaSpinner = ({
  label = 'Chargement...',
  helper = '',
  size = 'medium',
  center = true,
}) => {
  return (
    <div className={center ? 'nova-loader-inline center' : 'nova-loader-inline'}>
      <div className={`nova-spinner ${size}`} aria-hidden="true">
        <span />
      </div>

      {(label || helper) && (
        <div className="nova-loader-text">
          {label && <strong>{label}</strong>}
          {helper && <small>{helper}</small>}
        </div>
      )}
    </div>
  );
};

export const NovaPageLoader = ({
  label = 'Chargement de votre espace...',
  helper = 'Merci de patienter quelques secondes.',
}) => {
  return (
    <main className="nova-loader-page">
      <section className="nova-loader-card">
        <div className="nova-loader-logo-wrap">
          <img src="/NOVA PORTAGE Main Logo.png" alt="NOVA Portage" />
        </div>

        <NovaSpinner label={label} helper={helper} size="large" />

        <div className="nova-loader-skeletons" aria-hidden="true">
          <span />
          <span />
          <span />
        </div>
      </section>
    </main>
  );
};

export const NovaSectionLoader = ({
  label = 'Chargement des données...',
  helper = 'Les informations arrivent.',
}) => {
  return (
    <div className="nova-section-loader">
      <NovaSpinner label={label} helper={helper} size="medium" />
    </div>
  );
};

export const NovaButtonLoader = ({ label = 'Chargement' }) => {
  return (
    <span className="nova-button-loader" role="status" aria-label={label}>
      <span />
    </span>
  );
};

/*
  Important :
  On garde l’intercepteur uniquement pour notifier les pages CRA après ajout/suppression.
  On ne montre plus la barre globale en haut, pour éviter les doubles loaders.
*/
export const NovaNetworkLoader = () => {
  useEffect(() => {
    const responseInterceptor = axios.interceptors.response.use(
      (response) => {
        if (isCraMutation(response.config)) {
          notifyCraRefresh(response.config);
        }

        return response;
      },
      (error) => Promise.reject(error)
    );

    return () => {
      axios.interceptors.response.eject(responseInterceptor);
    };
  }, []);

  return null;
};
